module.exports = __webpack_public_path__ + "img/uz.9218402b.svg";